module.exports = __webpack_public_path__ + "228c7778c69f255eccf80b2ed036f7ff.png";